import { WorkflowState } from '../../enums/WorkflowState.enum';
import { DateTime } from 'luxon';
import { WorkflowData } from '@monorepo/interfaces';

export class WorkflowItemOperations {
    public static getStateColor(workflowState: string): string {
        switch (workflowState) {
            case WorkflowState.ACTIVE:
                return 'text-light-chartActiveState dark:text-dark-chartActiveState';
            case WorkflowState.DUE_SOON:
                return 'text-light-chartDueSoonState dark:text-dark-chartDueSoonState';
            case WorkflowState.OVERDUE:
                return 'text-light-chartOverdueState dark:text-dark-chartOverdueState';
            case WorkflowState.COMPLETED:
                return 'text-light-chartCompletedState dark:text-dark-chartCompletedState';
            default:
                return 'text-light-textColorSecondary dark:text-dark-textColorSecondary';
        }
    }
    public static getWorkflowState(workflow: WorkflowData): string {
        const now = DateTime.now();
        const startDate = DateTime.fromJSDate(workflow.startDate);
        const remainingDays = DateTime.fromJSDate(workflow.endDate)
            .startOf('day')
            .diff(DateTime.now().startOf('day'), 'days').days;
        if (workflow.completed) return WorkflowState.COMPLETED;
        if (remainingDays <= 0 && workflow.futureParticipants.length > 0) return WorkflowState.OVERDUE;
        if (remainingDays >= 0 && remainingDays <= 5 && startDate <= now) return WorkflowState.DUE_SOON;
        if (remainingDays > 5) return WorkflowState.ACTIVE;
        return WorkflowState.COMPLETED;
    }
}
